const styles = (theme) => ({
  quantity: {
    color: theme.color.green,
    margin: '-5px 8px 0 0',
  },
  avatarIconStyle: {
    backgroundColor: 'unset',
    marginRight: 8,
  },
  categoryArrow: {
    opacity: '54%',
    transform: 'rotate(180deg)',
  },
  menuText: {
    fontSize: '1.25rem',
    fontWeight: 300,
  },
});

export default styles;
